import create from "zustand";

export enum CouponUsageDetailsViewMode {
  APARTMENTS,
  USERS,
  RESERVATIONS,
}

export type SharedUsageDetailsStore = {
  viewMode: CouponUsageDetailsViewMode;
  setViewMode: (v: CouponUsageDetailsViewMode) => void;
};

export const useCouponUsageDetailsSharedStore = create<SharedUsageDetailsStore>(
  (set) => ({
    setViewMode: (v) => set((state) => ({ ...state, viewMode: v })),
    viewMode: CouponUsageDetailsViewMode.RESERVATIONS,
  })
);
